import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useMemo, useState } from 'react'
import {
	getNotifications,
	countUnreadNotifications,
	markAllNotificationsRead,
} from '../../features/notificationSlice'
import { Typography } from '@mui/material'
import ButtonCustom from '../../components/atoms/button/ButtonCustom'
import { NotificationTab } from '../../components/notification/NotificationTab'
import styles from './NotificationPage.module.scss'

export const UserNotificationPage = () => {
	const dispatch = useDispatch()
	const notifications = useSelector(
		(state) => state.notification.notifications
	)

	const [markingAll, setMarkingAll] = useState(false)

	useEffect(() => {
		dispatch(getNotifications())
		dispatch(countUnreadNotifications())
	}, [dispatch])

	const unread = useMemo(
		() => (notifications || []).filter((n) => n.status === 'unread'),
		[notifications]
	)

	const today = new Date()
	const formattedDate = today.toLocaleDateString('en-US', {
		day: '2-digit',
		month: 'short',
		year: 'numeric',
	})

	const handleMarkAllRead = async () => {
		if (!unread.length || markingAll) return
		setMarkingAll(true)
		try {
		  const unreadIds = unread.map(n => n._id)
		  await dispatch(markAllNotificationsRead(unreadIds))
		} finally {
		  setMarkingAll(false)
		}
	  }
	  

	return (
		<>
			<div className={styles.pageWrap}>
				<div className={styles.pageHeader}>
					<Typography component="h1">Notifications</Typography>
					<div className={styles.right}>
						<div className={styles.date}>
							<img
								src="/images/calendar_line.svg"
								alt="calendar_line.svg"
							/>
							<span>{formattedDate}</span>
						</div>
						<ButtonCustom
							variant="outlined"
							size="lg"
							className={styles.markAll}
							onClick={handleMarkAllRead}
							disabled={!unread.length || markingAll}
						>
							{markingAll ? 'Marking…' : 'Mark all as read'}
						</ButtonCustom>
					</div>
				</div>
				<NotificationTab 
                    notifications={notifications}
                />
			</div>
		</>
	)
}
